import $ from 'jquery'

let withSubMenu = $('#withSubMenu')
let burger = document.getElementById('burger-button')
let headerElement = document.getElementsByTagName('header')
let body = document.getElementsByTagName('body')

withSubMenu.click(function () {
    if (withSubMenu.attr("class") ===  'active') {
        $(this).removeClass('active')
        $('menu').removeClass('active-menu')
        $('header').removeClass('active')
    } else {
        $(this).addClass('active')
        $('menu').addClass('active-menu')
        $('header').addClass('active')
    }
})

if (window.innerWidth > 1024) {

    withSubMenu.mouseenter(function () {
        $(this).toggleClass('active')
        $('menu').toggleClass('active-menu')
        $('header').toggleClass('active')
    })

    withSubMenu.mouseleave(function () {
        $(this).removeClass('active')
        $('menu').removeClass('active-menu')
        $('header').removeClass('active')
    })
}

$(burger).click(function () {
    $(headerElement).toggleClass('open')
    if ($(body).css('overflow') === ('visible') || $(body).css('overflow') === ('auto')) {
        body[0].style.overflow = 'hidden'
    } else  {
        body[0].style.overflow = 'auto'
    }
})